import type { Position } from 'components/map/types';

import { RioPositionSchema } from './zod';

import type { PositionInput } from 'API';

export const transformToRioPosition = ({ latitude, longitude }: PositionInput): Position =>
    RioPositionSchema().parse({
        lat: latitude,
        lng: longitude,
    });
